import { getFirstDayOfMonth } from '../../bs-moment/utils/date-getters';
import { getStartingDayOfCalendar } from '../utils/bs-calendar-utils';
import { shiftDate } from '../../bs-moment/utils/date-setters';
export function calculateMonthModel(date, options) {
    var firstDay = getFirstDayOfMonth(date);
    var prevValue = getStartingDayOfCalendar(firstDay, options);
    var daysCalendar = new Array(options.height);
    for (var i = 0; i < options.height; i++) {
        daysCalendar[i] = new Array(options.width);
        for (var j = 0; j < options.width; j++) {
            daysCalendar[i][j] = prevValue;
            prevValue = shiftDate(prevValue, { day: 1 });
        }
    }
    return {
        daysMatrix: daysCalendar,
        month: firstDay
    };
}
//# sourceMappingURL=calc-month-view.js.map


//////////////////
// WEBPACK FOOTER
// /revet-web/node_modules/ngx-bootstrap/datepicker/engine/calc-month-view.js
// module id = ../../../../ngx-bootstrap/datepicker/engine/calc-month-view.js
// module chunks = vendor